var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":_vm.width,"type":"card"}})}
var staticRenderFns = []

export { render, staticRenderFns }